export function setupToggleContent() {
    const toggleTriggers = document.querySelectorAll(
        '[data-action="open-content"]'
    );

    function clickToggleTrigger(e) {
        const toggleTrigger = e.currentTarget;
        const target = document.querySelector(
            toggleTrigger.getAttribute("data-target")
        );
        if (target) {
            if (!target.classList.contains("js-open")) {
                toggleTrigger.classList.add("js-open");
                target.classList.add("js-open");

                // Set min-height instead of height
                target.style.minHeight = `${target.scrollHeight}px`;
                target.style.height = "auto"; // Allow content to expand

                if (
                    toggleTrigger.getAttribute("data-action-scroll") !=
                    "no-scroll"
                ) {
                    setTimeout(function () {
                        target.scrollIntoView({ behavior: "smooth" });
                    }, 300);
                }
                if (target.classList.contains("dialog")) {
                    document.querySelector("body").style.overflow = "hidden";
                }
            } else {
                toggleTrigger.classList.remove("js-open");
                target.classList.remove("js-open");

                // Reset both min-height and height
                target.style.minHeight = null;
                target.style.height = null;

                if (target.classList.contains("dialog")) {
                    document.querySelector("body").style.overflow = null;
                }
            }
        }
    }

    toggleTriggers.forEach((toggleTrigger) => {
        toggleTrigger.addEventListener("click", clickToggleTrigger);
    });
}
